// components/Blocks/HealthBlock.js
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import heart_img from '../../../../../../../img/heart.svg';
import FileUploader from '../../../../../../../components/FileUpload/FileUploader';

const HealthBlock = ({ 
  data, 
  onChange, 
  editable, 
  defaultOpen = false, 
  benefitsList = [], 
  specializationsList = [], 
  isViewOnly = false,
  onFileViewRequest,
  disabilitiesList = []
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleFieldChange = (field, value) => {
    if (isViewOnly) return;
    onChange(field, value);
  };

  const handleIllnessChange = (illnesses) => {
    if (isViewOnly) return;
    onChange('illnesses', illnesses);
  };

  const handleFilesChange = (files) => {
    if (isViewOnly) return;
    
    // Добавляем информацию о секции к каждому файлу
    const filesWithSection = files.map(file => ({
      ...file,
      section: 'health'
    }));
    
    onChange('healthFiles', filesWithSection);
  };

  const handleFileView = (file) => {
    onChange('healthFileView', file);
  };

  const handleFileDownload = (file) => {
    onChange('healthFileDownload', file);
  };

  const subtitle = data.healthSpecialization || 'немає';

  return (
    <div className="card-block">
      <button
        className="block-header"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="left">
          <img className="blk-icon" src={heart_img} alt="" />
          <span className="title">Спеціалізація за станом здоров'я</span>
          {!isOpen && <span className="subtitle">{subtitle}</span>}
        </div>
        <FontAwesomeIcon 
          icon={isOpen ? faChevronUp : faChevronDown} 
          className="chevron" 
        />
      </button>
      {isOpen && (
        <div className="block-body">
          <div className="row g-3 align-items-start">
            <div className="col-md-6">
              <div className="form-label">Тип труднощів</div>
              <select
                className="form-select"
                value={data.disabilitiesType || ''}
                onChange={(e) => handleFieldChange('disabilitiesType', e.target.value)}
                //onChange={(e) => handleIllnessChange(e.target.value ? [e.target.value] : [])}
                disabled={isViewOnly || !editable}
              >
                <option value="">Оберіть тип труднощів</option>
                {disabilitiesList?.map(spec => (
                  <option key={spec._id} value={spec._id}>
                    {spec.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-6">
              <div className="form-label">Документ</div>
              <input
                type="text"
                className="form-control"
                value={data.healthDocument}
                onChange={(e) => handleFieldChange('healthDocument', e.target.value)}
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-6">
              <div className="form-label">Дата видачі</div>
              <input
                type="date"
                className="form-control"
                value={data.healthDocumentDate}
                onChange={(e) => handleFieldChange('healthDocumentDate', e.target.value)}
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-6">
              <div className="form-label">Номер документа</div>
              <input
                type="text"
                className="form-control"
                value={data.healthDocumentNumber}
                onChange={(e) => handleFieldChange('healthDocumentNumber', e.target.value)}
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-6">
              <div className="form-label">Видано</div>
              <input
                type="text"
                className="form-control"
                value={data.healthDocumentIssuedBy}
                onChange={(e) => handleFieldChange('healthDocumentIssuedBy', e.target.value)}
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-6">
              <div className="form-label">Рівень підтримки</div>
              <select
                className="form-select"
                value={data.spec_educLevel}
                onChange={(e) => handleFieldChange('spec_educLevel', e.target.value)}
                disabled={isViewOnly || !editable}
              >
                {[0,1,2,3,4,5].map(l=><option value={l}>{l}</option>)}
              </select>
              
            </div>
          </div>

          {/* Используем FileUploader напрямую */}
          <FileUploader
            label="Завантажте файли"
            description="Файли у форматі PDF, JPG, PNG. Максимальний розмір файлу 2 МБ."
            value={data.healthFiles || []}
            onChange={handleFilesChange}
            onFileView={handleFileView}
            onFileDownload={handleFileDownload}
            editable={editable}
            disabled={isViewOnly || !editable}
            multiple={true}
            maxCount={10}
            asBase64={true}
            onFileViewRequest={onFileViewRequest}
          />
        </div>
      )}
    </div>
  );
};

export default HealthBlock;